import { Chart, registerables, ChartOptions } from "chart.js";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { getLineChartSettings, ChartData } from "./tankChart.utils";

Chart.register(...registerables);

interface TankChartProps {
  chartData: { moisture: number; timestamp: string }[];
}

interface ChartSettingsType {
  data?: ChartData;
  options?: {
    responsive?: boolean;
    scales?: {
      y?: any;
      x?: any;
    };
    plugins?: {
      tooltip?: {
        callbacks?: {
          label?: (context: any) => string;
        };
      };
      legend?: {
        labels?: any;
        display?: boolean;
      };
    };
    maintainAspectRatio?: boolean;
  };
  tankData?: { moisture: number; timestamp: string }[];
}

const addTankFillColorScale = (chartSettings: ChartSettingsType) => {
  
  return {
    ...chartSettings,
    options: {
      ...chartSettings.options,
      responsive: true,
      scales: {
        ...chartSettings.options?.scales,
        y: {
          ...chartSettings.options?.scales?.y,
          min: 0,
          max: 100,
          ticks: {
            callback: function(value: number) {
              return value + '%';
            }
          }
        },
        x: {
          ...chartSettings.options?.scales?.x,
          ticks: {
            callback: function(value: string | number, index: number, ticks: any[]) {
              if (chartSettings.tankData && chartSettings.tankData[index]) {
                const date = new Date(chartSettings.tankData[index].timestamp);
                return date.toLocaleString('en-US', {
                  month: 'numeric',
                  day: 'numeric',
                  hour: 'numeric',
                });
              }
              return value;
            }
          }
        }
      },
      plugins: {
        ...chartSettings.options?.plugins,
        legend: {
          ...chartSettings.options?.plugins?.legend,
          display: false
        },
        tooltip: {
          ...chartSettings.options?.plugins?.tooltip,
          callbacks: {
            ...chartSettings.options?.plugins?.tooltip?.callbacks,
            label: function(context: {parsed: {y: number}}) {
              const value = context.parsed.y;
              
              return `Tank Fill: ${value.toFixed(0)}%`;
            }
          }
        }
      },
      maintainAspectRatio: false
    }
  };
};

const TankChart = ({ chartData }: TankChartProps) => {
  const [chartSettings, setChartSettings] = useState<ChartSettingsType | null>(null);

  useEffect(() => {
    // Only consider data points that are valid (not null or undefined)
    const cleanedData = chartData.filter(cd => typeof cd.moisture === "number" && !isNaN(cd.moisture))

    try {
      const baseChartData = getLineChartSettings(cleanedData);
      
      const baseSettings: ChartSettingsType = {
        data: {
          ...baseChartData,
          datasets: [{
            ...baseChartData.datasets[0],
            borderColor: "rgb(2, 89, 250)", 
            borderWidth: 2,        
            pointBackgroundColor: "#ffffff"
          }]
        },
        options: {
          responsive: true,
          scales: {
            y: {
              min: 0,
              max: 100
            }
          },
          plugins: {
            legend: {
              display: false 
            }
          },
          maintainAspectRatio: false
        },
        tankData: cleanedData
      };
      
      const enhancedSettings = addTankFillColorScale(baseSettings); 
      setChartSettings(enhancedSettings);
    } catch (error) {
      console.error("Error setting up chart:", error);
      
      const basicChartData = getLineChartSettings(cleanedData);
      setChartSettings({
        data: basicChartData,
        options: {
          maintainAspectRatio: false
        }
      });
    }
  }, [chartData]);

  if (!chartSettings) return <div>Loading chart...</div>;

  return (
    <div>
      <div style={{ height: '350px' }}>
        {chartSettings && chartSettings.data && (
          <Line 
            data={chartSettings.data}
            options={chartSettings.options || {}} 
          />
        )}
      </div>
      
    </div>
  );
};

export default TankChart;
